import { useState, type FC } from 'react';
import { Check } from '@eqi-investimentos/icons/web';
import { Button } from '@eqi-investimentos/react';
import { CTA } from '../interface/CTA_Button';
import { useCreateSFOpportunity } from '@/modules/Customer/http/client/mutations/useCreateSFOpportunity';

export const CTAButton: FC<CTAButtonProps> = ({
  data: { label, action, campaign_id, product },
}) => {
  const { mutate: createOpportunity, isPending } = useCreateSFOpportunity();

  const [isOpportunitySent, setIsOpportunitySent] = useState(false);

  const handleCreateOpportunity = () => {
    const valuesOpportunity = {
      action: action!,
      product: product!,
      ...(campaign_id && { campaign_id: campaign_id! }),
    };

    createOpportunity(valuesOpportunity, {
      onSuccess: () => setIsOpportunitySent(true),
    });
  };

  if (isOpportunitySent) {
    return (
      <Button leftIcon={<Check />} disabled size="md" w="16rem">
        Notificamos o seu assessor
      </Button>
    );
  }

  return (
    <Button
      isLoading={isPending}
      size="md"
      {...(!isPending && { noOfLines: 1 })}
      w="16rem"
      onClick={handleCreateOpportunity}
    >
      {label}
    </Button>
  );
};

type CTAButtonProps = {
  data: CTA;
};
